import { useState } from 'react';
import { colors } from '../../../../../../../colorVars';
import { TextButton } from '../../../../../../atomic/atomicComponentLibrary/buttons/textButton/TextButton';
import { BoxSwitch } from '../../../../../../atomic/atomicComponentLibrary/switches/boxSwitch/BoxSwitch';
import { Body3, Body4, fontSizes } from '../../../../../../atomic/text/Text';
import { SelectOptionsModal } from '../selectOptionsModal/SelectOptionsModal';
import { ChainsTable } from './ChainsTable';
import style from './OptionChainsTable.module.css';
import { ValidOptionsTable } from './ValidOptionsTable';

export const OptionChainsTable = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [showValidOptions, setShowValidOptions] = useState(true);
  return (
    <div className={style.tableAndLabel}>
      <div>
        <BoxSwitch
          margin='5px 0 5px 5px'
          controlledValue={showValidOptions}
          setValue={setShowValidOptions}
          fontSize={fontSizes.body4}
          color="lightGrey"
          notSelectedColor="grey"
          selectedColor="green"
          title="display option"
          labels={['Valid', 'Selected']}
          values={[true, false]}
        />
        <div className={style.tableContainer}>
          {showValidOptions ? <ValidOptionsTable /> : <ChainsTable />}
        </div>
      </div>
      <TextButton
        clickHandler={() => {
          setModalOpen(true);
        }}
        loading={false}
        backgroundColor="blue"
        fontColor="lightGrey"
        size="small"
      >
        Select Options
      </TextButton>
      <SelectOptionsModal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
      />
    </div>
  );
};
